module.exports = __webpack_public_path__ + "r-v3/img/init.b5b7d9e3.svg";